/** Préférence son de notification Chat. */

export const CHAT_NOTIFICATION_SOUND_STORAGE_KEY = "chat_notification_sound_v1";

export type ChatNotificationSoundId =
  | "off"
  | "classic"
  | "new-message"
  | "incoming"
  | "soft"
  | "chime"
  | "pop"
  | "alert"
  | "announcement"
  | "ding"
  | "revealed"
  | "sms"
  | "phone"
  | "pop-ding"
  | "pop-ding-upbeat"
  | "pop-effect"
  | "soundjay";

export type ChatNotificationSoundOption = {
  id: ChatNotificationSoundId;
  label: string;
  file: string | null;
};

export const CHAT_NOTIFICATION_SOUND_OPTIONS: readonly ChatNotificationSoundOption[] = [
  { id: "off", label: "Aucun son", file: null },
  { id: "classic", label: "Classique", file: "mail-notification.wav" },
  { id: "new-message", label: "Nouveau message", file: "New Message Notification.mp3" },
  { id: "sms", label: "SMS", file: "Sms New Message.mp3" },
  { id: "incoming", label: "Arrivée", file: "Incoming Email 01.wav" },
  { id: "soft", label: "Discret", file: "Notification.mp3" },
  { id: "chime", label: "Carillon", file: "Notification.wav" },
  { id: "phone", label: "Téléphone", file: "PhoneNTF03.mp3" },
  { id: "pop", label: "Léger", file: "Accept Popper02.mp3" },
  { id: "pop-ding", label: "Pop ding", file: "Pop Ding Notification 05.wav" },
  { id: "pop-ding-upbeat", label: "Pop dynamique", file: "Pop Ding Upbeat Notification.wav" },
  { id: "pop-effect", label: "Pop effet", file: "Pop Ding Notification Effect 3.mp3" },
  { id: "alert", label: "Alerte", file: "09070 bonus alert.wav" },
  { id: "announcement", label: "Annonce", file: "Announcement Notification 01.wav" },
  { id: "ding", label: "Ding", file: "ding-notification.mp3" },
  { id: "revealed", label: "Ouverture", file: "Notification Revealed.wav" },
  { id: "soundjay", label: "Clair", file: "soundjay_notification_main-01.mp3" },
] as const;

const OPTION_BY_ID = new Map(
  CHAT_NOTIFICATION_SOUND_OPTIONS.map((option) => [option.id, option])
);

export function chatNotificationSoundUrl(file: string): string {
  return `./sound/${encodeURIComponent(file)}`;
}

export function readChatNotificationSoundId(): ChatNotificationSoundId {
  try {
    const raw = localStorage.getItem(CHAT_NOTIFICATION_SOUND_STORAGE_KEY);
    if (raw && OPTION_BY_ID.has(raw as ChatNotificationSoundId)) {
      return raw as ChatNotificationSoundId;
    }
    // Aligné Mail si déjà choisi
    const mail = localStorage.getItem("mail_notification_sound_v1");
    if (mail && OPTION_BY_ID.has(mail as ChatNotificationSoundId)) {
      return mail as ChatNotificationSoundId;
    }
  } catch {
    /* ignore */
  }
  return "new-message";
}

export function persistChatNotificationSoundId(id: ChatNotificationSoundId): void {
  try {
    localStorage.setItem(CHAT_NOTIFICATION_SOUND_STORAGE_KEY, id);
  } catch {
    /* ignore */
  }
}

export function getChatNotificationSoundOption(
  id: ChatNotificationSoundId = readChatNotificationSoundId()
): ChatNotificationSoundOption {
  return OPTION_BY_ID.get(id) ?? CHAT_NOTIFICATION_SOUND_OPTIONS[2]!;
}

/** Coupe le son de notif sans changer le son choisi. */
export const CHAT_NOTIFICATION_SOUND_MUTED_KEY = "chat_notification_sound_muted_v1";

export function readChatNotificationSoundMuted(): boolean {
  try {
    return localStorage.getItem(CHAT_NOTIFICATION_SOUND_MUTED_KEY) === "1";
  } catch {
    return false;
  }
}

export function persistChatNotificationSoundMuted(muted: boolean): void {
  try {
    localStorage.setItem(CHAT_NOTIFICATION_SOUND_MUTED_KEY, muted ? "1" : "0");
  } catch {
    /* ignore */
  }
}
